import { SMSService } from '@weave/schema-gen-ts/dist/schemas/sms/data/v3/sms_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaSMSDataV3Service = bindHTTP(SMSService);
export const serviceName = 'sms-data-v3' as const;
